import { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

function QuestionOption(
    { option,
        type,
        optionList,
        editMode,
        criteriaData,
        answerHidden,
        onQVariableSelect }
) {
    const [optionReplaced, setOptionReplaced] = useState(false);

    const changeQVariableSelect = (e, qVariable) => {

        let newValue = JSON.parse(e.target.value);
        let oldValue = qVariable;
        onQVariableSelect(newValue, oldValue, type);
    }


    const clickReplaceOption = (e) => {
        setOptionReplaced(!optionReplaced);
    }

    const clickRemoveOption = (e, origQVariable, type) => {
        onQVariableSelect(null, origQVariable, type);
    }


    const generateQVariableSelect = (qVariableList, origQVariable) => {


        if (qVariableList) {

            var optionList = qVariableList.map((item) => {

                let itemLabel = item.label;


                return (<option selected={JSON.stringify(item.quizzlerObject) === JSON.stringify(origQVariable.quizzlerObject)} key={JSON.stringify(item)} className='variableSelectOption' value={JSON.stringify(item)} >
                    {itemLabel}
                </option>
                )
            });

            return (

                <select className={optionReplaced ? 'variableSelect' : 'variableSelectHidden'} onChange={(e) => changeQVariableSelect(e, origQVariable, type)}>
                    {optionList}

                </select>
            )
        }

    }



    const generateOption = (qVariableList, origQVariable) => {

        return (

            <Box>

                <Box sx={{ display: 'flex', height: 30 }}>

                    {type === 'DISTRACTOR' && editMode && optionList.length > 2 &&

                        <IconButton aria-label="remove" size="small" onClick={(e) => clickRemoveOption(e, origQVariable, type)}><DeleteOutlinedIcon fontSize="small" /></IconButton>

                    }

                    {type === 'DISTRACTOR' && editMode && optionList.length <= 2 &&

                        <Box style={{ width: 30 }}></Box>

                    }

                    {type === 'CORRECT_OPTION' && editMode &&

                        <Box style={{ width: 30 }}></Box>

                    }

                    {qVariableList && editMode &&


                        <IconButton sx={{ marginLeft: '-5px' }} aria-label="replace" size="small" onClick={clickReplaceOption}><ChangeCircleOutlinedIcon fontSize="small" /></IconButton>


                    }


                    {!qVariableList && editMode &&
                        <Box style={{ width: 26 }}></Box>
                    }



                    {qVariableList && editMode && generateQVariableSelect(qVariableList, origQVariable)}

                    {!optionReplaced && <Box sx={{ alignSelf: 'center' }}><Typography sx={!answerHidden && type === 'CORRECT_OPTION' ? { fontWeight: 'bold', color: 'green' } : {}}>{option.label}</Typography></Box>}


                </Box>

            </Box >

        )

    }


    return generateOption((type === 'CORRECT_OPTION' ? criteriaData.correctOptionQVariableList : criteriaData.distractorQVariableList), option.qv);






}

export default QuestionOption;